import { useMutation } from '@tanstack/react-query';

import { EmployeeClient, EmployeePosition } from '../../clients';
import queryKeys from '../../queryKeys';
import { apiBaseUrl } from '../../../config';

interface FindEmployeeProps {
  query: string;
  position: EmployeePosition
}

const employeeClient = new EmployeeClient(apiBaseUrl);

function useFindEmployee() {
  return useMutation({
    mutationKey: [queryKeys.Employee.Find],
    mutationFn: ({ query, position }: FindEmployeeProps) => employeeClient.find(query, position),
  });
}

export default useFindEmployee;
